import { render, staticRenderFns } from "./ShopifyUtilities.vue?vue&type=template&id=6ab3fafe&"
import script from "./ShopifyUtilities.vue?vue&type=script&lang=js&"
export * from "./ShopifyUtilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports